<script setup lang="ts">
import "@/assets/styles/footer.css";
import {ChevronRight, Mail, MapPin, Phone} from "lucide-vue-next";
</script>

<template>
  <footer class="footer">

    <div class="footer-container">

      <!-- Firma -->
      <div class="footer-column">

        <div class="footer-brand">

          <img
              src="@/assets/images/logo.png"
              alt="Logo"
              class="footer-logo"
          />

          <div>
            <h2>Dachdecker</h2>
            <span>Firmenname</span>
          </div>

        </div>

        <p>
          Ihr zuverlässiger Partner für Dacharbeiten,
          Sanierungen, Reparaturen und Flachdachlösungen
          mit Qualität aus Meisterhand.
        </p>

      </div>

      <!-- Navigation -->
      <div class="footer-column">

        <h3>Navigation</h3>

        <nav class="footer-links">

          <a href="/">
            <ChevronRight size="18"/>
            Start</a>
          <a href="/ueber">
            <ChevronRight size="18"/>
            Über uns</a>
          <a href="/leistungen">
            <ChevronRight size="18"/>
            Leistungen</a>
          <a href="/referenzen">
            <ChevronRight size="18"/>
            Referenzen</a>
          <a href="/kontakt">
            <ChevronRight size="18"/>
            Kontakt</a><a href="/karriere">
          <ChevronRight size="18"/>
          Kontakt</a>

        </nav>

      </div>

      <!-- Kontakt -->
      <div class="footer-column">

        <h3>Kontakt</h3>

        <div class="footer-contact">

          <div class="contact-item">
            <MapPin size="18"/>
            <span>Mannheim & Umgebung</span>
          </div>

          <div class="contact-item">
            <Phone size="18"/>
            <span>+49 123 456789</span>
          </div>

          <div class="contact-item">
            <Mail size="18"/>
            <span>info@dachpro.de</span>
          </div>

        </div>

      </div>

    </div>

    <!-- Bottom -->
    <div class="footer-bottom">

      <p>© 2026 Dachdecker — Meisterbetrieb für Dacharbeiten</p>

      <div class="footer-bottom-links">
        <a href="/impressum">Impressum</a>
        <a href="/datenschutz">Datenschutz</a>
      </div>

    </div>

  </footer>
</template>

<style scoped>
</style>